export const CONTACT = {
  street: "Schauplatzgasse 39",
  city: "3011 Bern, Schweiz",
  email: "info@swissblockchainalliance.com",
  phones: ["+41 61 300 28 40", "+41 26 500 69 29"],
  phoneHrefs: ["tel:+41613002840", "tel:+41265006929"],
  portal: "/kundenbereich",
};

export const REGISTER = [
  { label: "Rechtsform", value: "Verein" },
  { label: "Sitz", value: "Bern (BE)" },
  { label: "Handelsregister-Nr.", value: "CH-036.6.076.139-0" },
  { label: "UID / MWST", value: "CHE-133.425.602" },
  { label: "Eintrag Handelsregister", value: "25.03.2019" },
];

export const ABOUT = [
  "Swiss Blockchain Alliance widmet sich dem Aufbau sicherer, widerstandsfähiger und konformer digitaler Infrastrukturen für Organisationen in risikoreichen und stark regulierten Umfeldern. Wir schliessen die Lücke zwischen Technologie, Sicherheitsbetrieb und Governance.",
  "Unser Fokus liegt darauf, Schwachstellen zu reduzieren, Sicherheitsstandards zu stärken und Unternehmen zu befähigen, sich sicher in komplexen digitalen Umgebungen zu bewegen.",
  "An der Schnittstelle von Technologie, Compliance und operativer Kontrolle entwickeln wir skalierbare, langfristige Sicherheitslösungen. Wir verstehen Sicherheit als kontinuierlichen und sich stetig weiterentwickelnden Prozess.",
  "Unsere spezialisierten Teams stärken die Widerstandsfähigkeit von Systemen durch fundierte Analysen, proaktive Abwehrstrategien und kontinuierliche Schutzmassnahmen.",
];

export const SERVICES = [
  {
    no: "01",
    title: "Zentrale Koordination",
    text: "Wir agieren als zentrale Schnittstelle zwischen technischen Teams, Entscheidungsträgern und Compliance-Verantwortlichen. Unser strukturierter Ansatz unterstützt eine wirksame Koordination und die konsistente Umsetzung von Sicherheitsmassnahmen.",
  },
  {
    no: "02",
    title: "Stärkung der Widerstandsfähigkeit",
    text: "Wir erhöhen die operative Widerstandsfähigkeit durch kontinuierliche Risikobewertungen, gezielte Optimierung von Systemschutz und laufende Anpassung der Sicherheitsstrategien an neue Bedrohungen und regulatorische Anforderungen.",
  },
  {
    no: "03",
    title: "Schutz kritischer Systeme",
    text: "Mehrschichtige Sicherheitsarchitekturen, kontinuierliche Überwachung und fortschrittliche Bedrohungserkennung stärken Sicherheit, Stabilität und Widerstandsfähigkeit kritischer digitaler Systeme.",
  },
];

export const WORKING_GROUPS = [
  "Swiss Blockchain Alliance befasst sich mit der sich stetig wandelnden Landschaft der Cybersicherheit, der digitalen Infrastruktur und neuer Technologien. Der Bedarf an sicheren, widerstandsfähigen und verantwortungsvoll verwalteten digitalen Umgebungen wächst kontinuierlich.",
  "Unser Ansatz verbindet fortschrittliche Sicherheitsframeworks mit praxisnaher Umsetzung, schützt kritische Systeme und unterstützt sichere digitale Identitäten, den Schutz personenbezogener Daten sowie transparente und prüfbare Prozesse.",
];

export const MEMBER_BENEFITS = [
  "Zugang zu einem etablierten Netzwerk aus Fachleuten, Organisationen und öffentlichen Institutionen.",
  "Austausch zu aktuellen Entwicklungen in Blockchain, Cybersicherheit und digitalen Infrastrukturen.",
  "Mitwirkung an Arbeitsgruppen und gemeinsamen Initiativen.",
  "Sichtbarkeit und Vernetzung innerhalb des Schweizer Blockchain-Ökosystems.",
];

export const PUBLICATIONS = [
  {
    slug: "netzwerksicherheit",
    code: "en",
    date: "23.04.2026",
    lang: "Deutsch / Englisch",
    img: "/legacy/Network-Security-in-a-Distributed-Environment-800x800.webp",
    title: "Netzwerksicherheit in einer verteilten Umgebung: Schutz moderner Systeme",
    teaser: "Wie verteilte Infrastrukturen geschützt und widerstandsfähig betrieben werden können.",
  },
  {
    slug: "identitaeten",
    code: "en",
    date: "23.04.2026",
    lang: "Deutsch / Englisch",
    img: "/legacy/Protecting-Access-in-a-Connected-World-800x800.webp",
    title: "Sicherheit digitaler Identitäten: Schutz von Zugängen in einer vernetzten Welt",
    teaser: "Identitäten und Zugänge sicher verwalten – über Systeme und Organisationen hinweg.",
  },
  {
    slug: "cloud-sicherheit",
    code: "en",
    date: "23.04.2026",
    lang: "Deutsch / Englisch",
    img: "/legacy/Securing-Cloud-Environments-800x800.webp",
    title: "Absicherung von Cloud-Umgebungen: Bewährte Verfahren für moderne Unternehmen",
    teaser: "Praktische Sicherheitsmassnahmen für moderne Cloud-Infrastrukturen.",
  },
  {
    slug: "incident-response",
    code: "en",
    date: "23.04.2026",
    lang: "Englisch",
    img: "/legacy/How-Organizations-Can-Minimize-Damage-and-Recover-Faster-800x800.webp",
    title: "Incident Response Planning: How Organizations Can Minimize Damage and Recover Faster",
    teaser: "A clear response plan helps organizations contain incidents and recover faster.",
  },
  {
    slug: "zero-trust",
    code: "en",
    date: "23.04.2026",
    lang: "Englisch",
    img: "/legacy/Strengthening-Enterprise-Security-Through-Zero-Trust-Architecture-800x800.jpg",
    title: "Strengthening Enterprise Security Through Zero Trust Architecture",
    teaser: "Apply continuous verification and least-privilege access across enterprise systems.",
  },
  {
    slug: "datenschutz-digital",
    code: "en",
    date: "20.04.2026",
    lang: "Englisch",
    img: "/legacy/b-800x800.webp",
    title: "Data Protection and Privacy: Building Trust in a Digital-First World",
    teaser: "Practical principles for protecting personal data and building digital trust.",
  },
];
